import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AreaModel } from '../../area.model';

@Component({
    selector: 'fi-area-delete-introduction-card',
    templateUrl: './area-delete-introduction-card.component.html',
    styleUrls: ['./area-delete-introduction-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AreaDeleteIntroductionCardComponent {
    @Input() area: AreaModel;
}
